import type { List } from 'immutable';

import { UNDO_REDUCER_KEY, type UndoStore } from './undoReducer';
import type { Undo } from './undoTypes';

type UndoState = Record<typeof UNDO_REDUCER_KEY, UndoStore>;

const getStore = (state: UndoState): UndoStore => state[UNDO_REDUCER_KEY];

export const getUndoStack = (state: UndoState): List<Undo> => getStore(state).undoStack;
